import * as actions from "../actions";
import * as api from "../../api";
import { pushSourceToken } from 'utils';

export const fetchDocuments = (params = {}) => {
  return (dispatch, getState) => {
    const {token, user} = getState().auth;
    const auth = getState().auth;
    let sourceToken = pushSourceToken("FETCH_DOCUMENTS", dispatch);

    if (!params.filter) {
      params.filter = [];
    }

    if (('ADMIN'=== auth.loggedAs || (user && "ADMIN" === user.type) || 'ACCOUNTANT' === auth.loggedAs) && null !== auth.currentClient && null !== auth.currentClient.id) {
     params.filter.push({
        "property": "issuer",
        "value": auth.currentClient.id,
        "operator": "eq"
      });
    }

    if (('ADMIN'!== auth.loggedAs & (user && "USER" === user.type)) && null !== auth.user.id && 'ACCOUNTANT'!== auth.loggedAs) {
      params.filter.push({
        "property": "user",
        "value": auth.user.id,
        "operator": "eq"
      });
    }

    return dispatch(actions.fetchDocuments(api.fetchDocuments({token, params, sourceToken})));
  };
};

export const fetchDocumentsApp = () => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return dispatch(actions.fetchDocumentsApp(api.fetchDocumentsApp(token)));
  };
};

export const fetchDocument = (documentId) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return dispatch(actions.fetchDocument(api.fetchDocument(token, documentId)));
  };
};


export const modifyDocument = (documentId, documentOrganization, documentStreet, documentPostalCode, documentUen, type, locality, adressLine2,orderNumber) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return dispatch(actions.modifyDocument(api.modifyDocument(token, documentId, documentOrganization, documentStreet, documentPostalCode, documentUen, type, locality,adressLine2,orderNumber)));
  };
};

export const cancelOrder = (orderId) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.cancelOrder(token, orderId);
  };
};



export const modifyDocumentComment = (documentId,type, comment) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.modifyDocumentComment(token, documentId, type, comment);
  };
};

export const regenerateAndSendDocument = (documentId, documentType, regenerate, sendEmail) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return dispatch(actions.regenerateAndSendDocument(api.regenerateAndSendDocument(token, documentId, documentType, regenerate, sendEmail)));
  };
};


export const getDocumentLinesForDocument = (documentId, documentType) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return dispatch(actions.getDocumentLinesForDocument(api.getDocumentLinesForDocument(token, documentId, documentType)));
  };
};

export const getPaymentForDocument = (documentId, documentType) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return dispatch(actions.getPaymentForDocument(api.getPaymentForDocument(token, documentId, documentType)));
  };
};


export const fetchDocumentsAppRef = (issuerId, year, appType) => {
  return (dispatch, getState) => {
    let sourceToken = pushSourceToken("FETCH_DOCUMENTS_APP_REF", dispatch);
    const {token} = getState().auth;
    return dispatch(actions.fetchDocumentsAppRef(api.fetchDocumentsAppRef(token, issuerId, year,appType, sourceToken)));
  };
};


export const getDocumentStats = (dates, issuer, app, appRef, search, status, orderStatus) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return dispatch(actions.getDocumentStats(api.getDocumentStats(token, dates, issuer, app, appRef, search, status, orderStatus)));
  };
};


export const displayEfffDocumentFile = (documentId, documentType, officialNumber, documentUserId) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.displayEfffDocumentFile(token, documentId, documentType, officialNumber, documentUserId);
  };
};


export const fetchOrderByVcs = (vcs) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.fetchOrderByVcs(token, vcs);
  };
};

export const checkForMangopayPayment = (creditNoteId) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.checkForMangopayPayment(token, creditNoteId);
  };
};

export const changeOrdersRefundStatus = (orderIds) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.changeOrdersRefundStatus(token, orderIds);
  };
};



export const fetchCreditNotesByOrder = (orderId) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.fetchCreditNotesByOrder(token, orderId);
  };
};

export const createCreditNote = (invoiceId) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.createCreditNote(token, invoiceId);
  };
};

export const createPartialCreditNote = (invoiceId, description, vatRate, includingVatAmount, excludingVatAmount) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.createPartialCreditNote(token, invoiceId, description, vatRate, includingVatAmount, excludingVatAmount);
  };
};

export const generateCreditNote = (invoiceId, cnLines, includingVatAmountTotal, excludingVatAmountTotal, comment, isCancellingRegistration) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.generateCreditNote(token, invoiceId, cnLines, includingVatAmountTotal, excludingVatAmountTotal, comment, isCancellingRegistration);
  };
};

export const checkIfRegistrationIsCancelable = (invoiceId) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.checkIfRegistrationIsCancelable(token, invoiceId);
  };
};


export const getCountDocumentsForFtpUpload = (app, appRef, issuerId, year, discriminant, appType) => {
  return (dispatch, getState) => {
    let sourceToken = pushSourceToken("GET_COUNT_DOCUMENTS_FTP_UPLOAD", dispatch);
    const {token} = getState().auth;
    return dispatch(actions.getCountDocumentsForFtpUpload(api.getCountDocumentsForFtpUpload(token, app, appRef, issuerId, year, discriminant, appType, sourceToken)));
  };
};

export const startUploadDocumentsForFtpUploadCommand = (app, appRef, issuerId, year, discriminant, appType) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.startUploadDocumentsForFtpUploadCommand(token, app, appRef, issuerId, year, discriminant, appType);
  };
};

export const getDocumentGuest = (guestId) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.getDocumentGuest(token, guestId);
  };
};


export const modifyReminderState = (documentId) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.modifyReminderState(token, documentId);
  };
};

export const validateVatNumber = (uen) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.validateVatNumber(token, uen);
  };
};



// WEBPACK FOOTER //
// ./app/actions/thunks/documents.js